import React from 'react';
import { GlobeIcon, TargetIcon, TrendingUpIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function ServicesSection() {
  const services = [{
    icon: <GlobeIcon className="w-10 h-10 text-turquoise" data-id="element-206" />,
    title: 'Conversion Websites',
    description: 'Sitios institucionales que proyectan autoridad global. Diseñamos experiencias digitales inmersivas que no solo se ven espectaculares, sino que guían al usuario estratégicamente hacia la conversión.'
  }, {
    icon: <TargetIcon className="w-10 h-10 text-turquoise" data-id="element-207" />,
    title: 'High-Performance Landing Pages',
    description: 'Estructuras quirúrgicas para captación masiva de leads. Eliminamos distracciones y aplicamos copywriting persuasivo para maximizar el retorno de tu inversión publicitaria.'
  }, {
    icon: <TrendingUpIcon className="w-10 h-10 text-turquoise" data-id="element-208" />,
    title: 'Strategic Media Buyer',
    description: 'Gestión experta de pauta publicitaria en Meta y Google Ads para maximizar el ROAS. Llevamos tráfico calificado a tus activos digitales con segmentación láser.'
  }];
  return <section id="servicios" className="py-24 bg-petrol relative" data-id="element-209">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-210">
        <FadeIn className="mb-20" data-id="element-211">
          <div className="flex items-center gap-4 mb-4" data-id="element-212">
            <div className="h-[1px] w-12 bg-turquoise" data-id="element-213"></div>
            <span className="text-turquoise uppercase tracking-widest text-sm font-semibold" data-id="element-214">
              Nuestra Expertise
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold" data-id="element-215">
            Servicios de Alto Impacto
          </h2>
        </FadeIn>

        <div className="space-y-12" data-id="element-216">
          {services.map((service, index) => <FadeIn key={index} delay={index * 0.1} direction={index % 2 === 0 ? 'left' : 'right'} className="flex flex-col md:flex-row gap-8 items-start md:items-center bg-petrol-light p-8 md:p-12 rounded-2xl border border-petrol-lighter hover:border-turquoise/20 transition-colors relative overflow-hidden group" data-id="element-217">
              {/* Subtle tech accent on hover */}
              <div className="absolute top-0 left-0 w-1 h-full bg-turquoise opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-218"></div>

              <div className="flex-shrink-0 w-20 h-20 rounded-2xl bg-petrol flex items-center justify-center border border-petrol-lighter shadow-inner group-hover:border-turquoise/30 transition-colors" data-id="element-219">
                {service.icon}
              </div>
              <div className="flex-grow" data-id="element-220">
                <h3 className="text-2xl font-bold mb-4 text-white" data-id="element-221">
                  {service.title}
                </h3>
                <p className="text-silver text-lg leading-relaxed max-w-3xl" data-id="element-222">
                  {service.description}
                </p>
              </div>
              <div className="hidden md:block w-px h-24 bg-gradient-to-b from-transparent via-petrol-lighter to-transparent mx-8" data-id="element-223"></div>
              <div className="flex-shrink-0" data-id="element-224">
                <a href="https://wa.me/50672642898" target="_blank" rel="noopener noreferrer" className="text-turquoise hover:text-white font-medium flex items-center gap-2 transition-colors group/link" data-id="element-225">
                  Consultar
                  <span className="group-hover/link:translate-x-1 transition-transform" data-id="element-226">
                    →
                  </span>
                </a>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}